module.exports = __webpack_public_path__ + "static/img/hrmonster_logo_u.9af4851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/hrmonster_logo_u.png
// module id = FF0/
// module chunks = 0